import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.digital_twin');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

const PROJECT_WORKFLOW_ID_KEY = 'actuator:lastProjectId';

@Component({
    standalone: false,
    selector: 'wiz-page-digital_twin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.digital_twin/view.scss */
:host {
  display: block;
  height: 100%;
}

.twin-shell {
  background: linear-gradient(135deg, var(--twin-bg-start), var(--twin-bg-mid), var(--twin-bg-end));
  color: var(--twin-text);
  transition: background-color 180ms ease, color 180ms ease;
  --twin-bg-start: #f8fafc;
  --twin-bg-mid: #ffffff;
  --twin-bg-end: #e2e8f0;
  --twin-text: #0f172a;
  --twin-muted: #64748b;
  --twin-border: rgba(148, 163, 184, 0.36);
  --twin-card: rgba(255, 255, 255, 0.88);
  --twin-card-soft: rgba(248, 250, 252, 0.92);
  --twin-row: rgba(241, 245, 249, 0.78);
}

:host-context(.dark) .twin-shell,
.twin-dark {
  --twin-bg-start: #020617;
  --twin-bg-mid: #0f172a;
  --twin-bg-end: #18181b;
  --twin-text: #f8fafc;
  --twin-muted: #94a3b8;
  --twin-border: rgba(255, 255, 255, 0.1);
  --twin-card: rgba(15, 23, 42, 0.62);
  --twin-card-soft: rgba(2, 6, 23, 0.44);
  --twin-row: rgba(255, 255, 255, 0.05);
}

.twin-mode-switch {
  border-color: var(--twin-border);
  background: var(--twin-card-soft);
  color: var(--twin-muted);
}

.twin-mode-switch .is-active {
  background: #0f172a;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

:host-context(.dark) .twin-mode-switch .is-active,
.twin-dark .twin-mode-switch .is-active {
  background: #ffffff;
  color: #0f172a;
}

.twin-kpi-panel {
  min-width: 0;
}

.twin-kpi-grid {
  container-type: inline-size;
  grid-template-columns: repeat(auto-fit, minmax(112px, 1fr));
}

.twin-kpi-tile {
  min-width: 112px;
  min-height: 104px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.twin-kpi-label {
  letter-spacing: 0.16em;
  line-height: 1.2;
  white-space: nowrap;
}

.twin-kpi-value {
  font-size: 20px;
  line-height: 1.15;
  max-width: 100%;
  overflow: hidden;
  text-align: left;
  text-overflow: clip;
  white-space: nowrap;
}

.twin-kpi-desc {
  margin-top: 6px;
  max-width: 100%;
  overflow: hidden;
  line-height: 1.25;
  text-overflow: clip;
  white-space: nowrap;
}

@container (max-width: 520px) {
  .twin-kpi-value {
    font-size: 18px;
  }
}
@container (max-width: 430px) {
  .twin-kpi-grid {
    grid-template-columns: repeat(2, minmax(112px, 1fr));
  }
  .twin-kpi-label {
    letter-spacing: 0.14em;
  }
  .twin-kpi-value {
    font-size: 16px;
  }
}
@container (max-width: 300px) {
  .twin-kpi-value {
    font-size: 14px;
  }
}
.twin-feature-label {
  font-weight: 700;
}

.twin-light [class*="border-white/"],
.twin-light [class*=border-white] {
  border-color: var(--twin-border) !important;
}

.twin-light [class*="divide-white/"] > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--twin-border) !important;
}

.twin-light [class*=bg-slate-950],
.twin-light [class*="bg-white/5"],
.twin-light [class*="bg-white/8"] {
  background-color: var(--twin-card) !important;
}

.twin-light [class*=bg-slate-800] {
  background-color: #e2e8f0 !important;
}

.twin-light thead [class*="bg-white/5"],
.twin-light tr[class*="bg-white/5"] {
  background-color: var(--twin-row) !important;
}

.twin-light .text-white,
.twin-light .text-slate-100,
.twin-light .text-slate-200 {
  color: var(--twin-text) !important;
}

.twin-light .text-slate-300,
.twin-light .text-slate-400,
.twin-light .text-slate-500 {
  color: var(--twin-muted) !important;
}

.twin-light .text-cyan-100,
.twin-light .text-cyan-200,
.twin-light .text-cyan-300 {
  color: #0e7490 !important;
}

.twin-light .text-sky-100,
.twin-light .text-sky-200,
.twin-light .text-sky-300 {
  color: #0369a1 !important;
}

.twin-light .text-emerald-100,
.twin-light .text-emerald-200,
.twin-light .text-emerald-300 {
  color: #047857 !important;
}

.twin-light .text-amber-100,
.twin-light .text-amber-200,
.twin-light .text-amber-300 {
  color: #b45309 !important;
}

.twin-light .text-orange-100,
.twin-light .text-orange-200,
.twin-light .text-orange-300 {
  color: #c2410c !important;
}

.twin-light .twin-feature-cyan {
  color: #0891b2 !important;
}

.twin-light .twin-feature-orange {
  color: #ea580c !important;
}

.twin-light .twin-feature-emerald {
  color: #059669 !important;
}

.twin-light [class*=shadow-slate-950] {
  box-shadow: 0 20px 45px rgba(148, 163, 184, 0.24) !important;
}

.twin-light tbody tr:hover {
  background-color: rgba(241, 245, 249, 0.72) !important;
}

canvas {
  touch-action: none;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}`],
})
export class PageDigital_twinComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {}

    private timer: any = null;
    public theme: 'light' | 'dark' = 'light';
    public projectId: string = '';
    public projectOptions: any[] = [];
    public projectMessage: string = '';

    private get isDark(): boolean { return this.theme === 'dark'; }

    // Real-time KPI
    public loadRatio: number = 0;
    public efficiency: number = 0;
    public currentDraw: number = 0;
    public temperature: number = 0;
    public batteryConsumption: number = 0;
    public voltage: number = 12.6;
    public usingRealData: boolean = false;
    public kFieldPos: number | null = null;

    public loadSegments: any[] = [];
    public tempAnalysis: any[] = [];
    public alarms: any[] = [];
    public lastUpdated: string = '';

    // Sparkline ring buffers
    public seriesLoad: number[] = [];
    public seriesEff: number[] = [];
    public seriesCurr: number[] = [];
    public seriesTemp: number[] = [];
    private RING_MAX = 30;

    // ── Socket.IO ──────────────────────────────────────────────────────────
    private socket: any = null;
    public socketConnected: boolean = false;

    // ──────────────────────────────────────────────────────────────────────

    public sparkline(arr: number[], width: number = 100, height: number = 28): string {
        if (!arr || arr.length === 0) return '';
        const max = Math.max(...arr), min = Math.min(...arr), range = (max - min) || 1;
        const step = arr.length > 1 ? width / (arr.length - 1) : 0;
        return arr.map((v, i) => {
            const x = (i * step).toFixed(1);
            const y = (height - ((v - min) / range) * height).toFixed(1);
            return `${x},${y}`;
        }).join(' ');
    }

    // ──────────────────────────────────────────────────────────────────────

    public async ngOnInit() {
        await this.service.init();
        this.projectId = this.routeProjectId();
        this.syncGlobalTheme();
        await this.loadProjects();
        this.ensureProjectScope();
        if (this.projectId) {
            await this.loadMonitorData();
            await this.loadAlarms();
        } else {
            this.resetRealtimeData();
        }
        await this.loadTempAnalysis();
        if (this.projectId) this.connectSocket();
        this.startPolling();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
        if (this.socket) { this.socket.disconnect(); this.socket = null; }
    }

    private syncGlobalTheme() {
        try {
            const saved = localStorage.getItem('appTheme');
            this.theme = saved === 'dark' ? 'dark' : 'light';
        } catch (e) { this.theme = 'light'; }
    }

    private routeProjectId(): string {
        const params = new URLSearchParams(location.search);
        const queryId = params.get('project_id') || '';
        if (queryId) return queryId;
        try {
            return localStorage.getItem(PROJECT_WORKFLOW_ID_KEY) || '';
        } catch (e) {
            return '';
        }
    }

    private rememberProjectId(id: string) {
        if (!id) return;
        try {
            localStorage.setItem(PROJECT_WORKFLOW_ID_KEY, id);
        } catch (e) {}
    }

    private updateRouteProjectId(id: string) {
        try {
            const url = new URL(location.href);
            if (id) url.searchParams.set('project_id', id);
            else url.searchParams.delete('project_id');
            history.replaceState(null, '', url.toString());
        } catch (e) {}
    }

    private async loadProjects() {
        const { code, data } = await wiz.call("projects");
        if (code === 200) {
            this.projectOptions = data || [];
        }
    }

    private ensureProjectScope() {
        const exists = (this.projectOptions || []).some((p: any) => p.id === this.projectId);
        if (this.projectId && !exists) {
            this.projectId = '';
        }
        if (!this.projectId && this.projectOptions.length > 0) {
            this.projectId = this.projectOptions[0].id;
        }
        if (this.projectId) {
            this.projectMessage = '';
            this.rememberProjectId(this.projectId);
            this.updateRouteProjectId(this.projectId);
        } else {
            this.projectMessage = '디지털 트윈 운영 모니터링을 시작하려면 먼저 프로젝트가 필요합니다.';
        }
    }

    public selectedProject(): any {
        return (this.projectOptions || []).find((p: any) => p.id === this.projectId) || null;
    }

    public selectedProjectLabel(): string {
        const project = this.selectedProject();
        if (!project) return '프로젝트 미선택';
        const meta = [project.vehicle, project.partType].filter((v: string) => !!v).join(' · ');
        return meta ? `${project.title} (${meta})` : project.title;
    }

    public projectDigitalTwinUrl(): string {
        return this.projectId ? `/projects/${encodeURIComponent(this.projectId)}/digital_twin` : '/projects';
    }

    public goProjectDigitalTwin() {
        this.service.href(this.projectDigitalTwinUrl());
    }

    private resetRealtimeData() {
        this.loadRatio = 0;
        this.efficiency = 0;
        this.currentDraw = 0;
        this.temperature = 0;
        this.batteryConsumption = 0;
        this.voltage = 12.6;
        this.usingRealData = false;
        this.kFieldPos = null;
        this.loadSegments = [];
        this.alarms = [];
        this.lastUpdated = '';
        this.seriesLoad = [];
        this.seriesEff = [];
        this.seriesCurr = [];
        this.seriesTemp = [];
    }

    public async selectProject(projectId: string) {
        if (!projectId || projectId === this.projectId) return;
        this.projectId = projectId;
        this.projectMessage = '';
        this.rememberProjectId(projectId);
        this.updateRouteProjectId(projectId);
        this.resetRealtimeData();
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            this.socketConnected = false;
        }
        await this.loadMonitorData();
        await this.loadAlarms();
        this.connectSocket();
        await this.service.render();
    }

    // ── Data loading ───────────────────────────────────────────────────────
    private async loadMonitorData() {
        if (!this.projectId) {
            this.resetRealtimeData();
            return;
        }
        const params = this.projectId ? { project_id: this.projectId } : {};
        const { code, data } = await wiz.call("monitor", params);
        if (code === 200) {
            this.loadRatio = data.loadRatio;
            this.efficiency = data.efficiency;
            this.currentDraw = data.currentDraw;
            this.temperature = data.temperature;
            this.batteryConsumption = data.batteryConsumption;
            this.voltage = data.voltage ?? this.voltage;
            this.usingRealData = data.usingRealData ?? false;
            this.loadSegments = data.loadSegments || [];
            this.lastUpdated = data.timestamp || '';
            if (data.fieldPosition != null) this.kFieldPos = data.fieldPosition;
            this.seriesLoad = [...this.seriesLoad, this.loadRatio].slice(-this.RING_MAX);
            this.seriesEff = [...this.seriesEff, this.efficiency].slice(-this.RING_MAX);
            this.seriesCurr = [...this.seriesCurr, this.currentDraw].slice(-this.RING_MAX);
            this.seriesTemp = [...this.seriesTemp, this.temperature].slice(-this.RING_MAX);
        }
    }

    private async loadAlarms() {
        if (!this.projectId) {
            this.alarms = [];
            return;
        }
        const params = this.projectId ? { project_id: this.projectId } : {};
        const { code, data } = await wiz.call("alarms", params);
        if (code === 200) { this.alarms = data; }
    }


    private async loadTempAnalysis() {
        const { code, data } = await wiz.call("temp_analysis");
        if (code === 200) { this.tempAnalysis = data; }
    }

    // ── Polling ───────────────────────────────────────────────────────────
    private startPolling() {
        this.timer = setInterval(async () => {
            this.syncGlobalTheme();
            if (this.projectId && !this.socketConnected) {
                await this.loadMonitorData();
                await this.loadAlarms();
                await this.service.render();
            }
        }, 5000);
    }

    // ── Socket.IO ─────────────────────────────────────────────────────────
    private connectSocket() {
        if (!this.projectId) return;
        try {
            this.socket = wiz.socket();
            this.socket.on('connect', () => {
                this.socketConnected = true;
                this.socket.emit('subscribe', { project_id: this.projectId || '' });
            });
            this.socket.on('disconnect', () => { this.socketConnected = false; });
            this.socket.on('monitor_update', async (data: any) => {
                this.loadRatio = data.loadRatio ?? this.loadRatio;
                this.efficiency = data.efficiency ?? this.efficiency;
                this.currentDraw = data.currentDraw ?? this.currentDraw;
                this.temperature = data.temperature ?? this.temperature;
                this.voltage = data.voltage ?? this.voltage;
                this.batteryConsumption = data.batteryConsumption ?? this.batteryConsumption;
                this.usingRealData = data.usingRealData ?? false;
                this.lastUpdated = data.timestamp || '';
                this.seriesLoad = [...this.seriesLoad, this.loadRatio].slice(-this.RING_MAX);
                this.seriesEff = [...this.seriesEff, this.efficiency].slice(-this.RING_MAX);
                this.seriesCurr = [...this.seriesCurr, this.currentDraw].slice(-this.RING_MAX);
                this.seriesTemp = [...this.seriesTemp, this.temperature].slice(-this.RING_MAX);
                await this.service.render();
            });
        } catch (e) { this.socketConnected = false; }
    }

    // ── Color helpers ──────────────────────────────────────────────────────
    public getLoadColor(status: string): string {
        if (status === 'critical') return this.theme === 'dark' ? 'text-orange-200' : 'text-orange-700';
        if (status === 'warning') return this.theme === 'dark' ? 'text-amber-200' : 'text-amber-700';
        return this.theme === 'dark' ? 'text-cyan-200' : 'text-cyan-700';
    }

    public getLoadBg(status: string): string {
        if (status === 'critical') return this.theme === 'dark' ? 'bg-orange-300/6' : 'bg-orange-50';
        if (status === 'warning') return this.theme === 'dark' ? 'bg-amber-300/6' : 'bg-amber-50';
        return '';
    }

    public getKpiColor(type: string): string {
        if (type === 'load') {
            if (this.loadRatio > 85) return this.theme === 'dark' ? 'text-orange-200' : 'text-orange-700';
            if (this.loadRatio > 70) return this.theme === 'dark' ? 'text-amber-200' : 'text-amber-700';
            return this.theme === 'dark' ? 'text-cyan-200' : 'text-cyan-700';
        }
        if (type === 'efficiency') {
            if (this.efficiency < 80) return this.theme === 'dark' ? 'text-orange-200' : 'text-orange-700';
            if (this.efficiency < 90) return this.theme === 'dark' ? 'text-amber-200' : 'text-amber-700';
            return this.theme === 'dark' ? 'text-emerald-200' : 'text-emerald-700';
        }
        if (type === 'current') return this.theme === 'dark' ? 'text-sky-200' : 'text-sky-700';
        if (type === 'temperature') {
            if (this.temperature > 55) return this.theme === 'dark' ? 'text-orange-200' : 'text-orange-700';
            if (this.temperature > 40) return this.theme === 'dark' ? 'text-amber-200' : 'text-amber-700';
            return this.theme === 'dark' ? 'text-emerald-200' : 'text-emerald-700';
        }
        return this.theme === 'dark' ? 'text-slate-100' : 'text-slate-900';
    }

    public getKpiBg(type: string): string {
        if (type === 'load') {
            if (this.loadRatio > 85) return 'bg-orange-300/10 border-orange-300/25';
            if (this.loadRatio > 70) return 'bg-amber-300/10 border-amber-300/25';
            return 'bg-cyan-300/10 border-cyan-300/25';
        }
        if (type === 'efficiency') return 'bg-emerald-300/10 border-emerald-300/25';
        if (type === 'current') return 'bg-sky-300/10 border-sky-300/25';
        if (type === 'temperature') {
            if (this.temperature > 55) return 'bg-orange-300/10 border-orange-300/25';
            if (this.temperature > 40) return 'bg-amber-300/10 border-amber-300/25';
            return 'bg-emerald-300/10 border-emerald-300/25';
        }
        return 'bg-white/5 border-white/10';
    }

    public getTempStatus(status: string): string {
        if (status === '경고') return this.theme === 'dark' ? 'border-orange-300/30 bg-orange-300/12 text-orange-100' : 'border-orange-200 bg-orange-50 text-orange-700';
        if (status === '주의') return this.theme === 'dark' ? 'border-amber-300/30 bg-amber-300/12 text-amber-100' : 'border-amber-200 bg-amber-50 text-amber-700';
        if (status === '저하') return this.theme === 'dark' ? 'border-sky-300/30 bg-sky-300/12 text-sky-100' : 'border-sky-200 bg-sky-50 text-sky-700';
        if (status === '최적') return this.theme === 'dark' ? 'border-emerald-300/30 bg-emerald-300/12 text-emerald-100' : 'border-emerald-200 bg-emerald-50 text-emerald-700';
        return this.theme === 'dark' ? 'border-white/10 bg-white/5 text-slate-300' : 'border-slate-200 bg-slate-50 text-slate-600';
    }

    public getSeverityBadge(severity: string): string {
        if (severity === 'critical') return this.theme === 'dark' ? 'border-orange-300/30 bg-orange-300/12 text-orange-100' : 'border-orange-200 bg-orange-50 text-orange-700';
        if (severity === 'warning') return this.theme === 'dark' ? 'border-amber-300/30 bg-amber-300/12 text-amber-100' : 'border-amber-200 bg-amber-50 text-amber-700';
        return this.theme === 'dark' ? 'border-sky-300/30 bg-sky-300/12 text-sky-100' : 'border-sky-200 bg-sky-50 text-sky-700';
    }

    public getSeverityLabel(severity: string): string {
        if (severity === 'critical') return '위험';
        if (severity === 'warning') return '경고';
        return '정보';
    }

    public filterAlarms(severity: string): any[] {
        return (this.alarms || []).filter((a: any) => a.severity === severity);
    }

    public async resolveAlarm(alarmId: string) {
        const { code } = await wiz.call("resolve_alarm", { id: alarmId });
        if (code === 200) { await this.loadAlarms(); await this.service.render(); }
    }
}

export default PageDigital_twinComponent;